import React from 'react';
import { CTAButton } from './CTAButton';
import { CHECKOUT_URL, modules } from '../data/atlas';
export function ModulesSection() {
  return <section className="border-y-4 border-ice bg-white px-4 py-6 sm:py-8" data-id="element-90" data-mp="1ntd21ihaxv4u">
      <div className="mx-auto max-w-4xl" data-id="element-91" data-mp="1iwmkeqpumrhb">
        <h2 className="text-center text-2xl leading-none text-navy sm:text-3xl" data-id="element-92" data-mp="1it8j7lsx8obg">
          What’s Inside
        </h2>

        <div className="mt-4 grid gap-3 sm:grid-cols-2" data-id="element-93" data-mp="2bjyz6eprpv02">
          {modules.map(module => <a key={module.num} href={CHECKOUT_URL} className="flex flex-col rounded-lg border border-navy/10 bg-warm p-4 shadow-sm transition-colors duration-150 hover:border-teal" data-id="element-94" data-mp="26lfaw7npc74j">
              <p className="text-xs font-extrabold uppercase tracking-wide text-teal" data-id="element-95" data-mp="1wm6kfos1pamx">
                ✅ Module {module.num}
              </p>
              <h3 className="mt-1 text-base leading-tight text-navy sm:text-lg" data-id="element-96" data-mp="q4jgxjg4qcy4">
                {module.title}
              </h3>
              <p className="mt-1.5 text-sm font-medium leading-snug text-slate2" data-id="element-97" data-mp="1iupbgo12fitm">
                {module.body}
              </p>
              <p className="mt-auto pt-2 text-sm font-extrabold text-navy" data-id="element-98" data-mp="1nt0lozv9vvcd">
                {module.kicker}
              </p>
            </a>)}
        </div>

        <CTAButton className="mx-auto mt-4 max-w-md" data-id="element-99" data-mp="1dvmd1mflcaum">
          🦷 YES! I WANT THE COMPLETE SYSTEM
        </CTAButton>
      </div>
    </section>;
}